import { Tabs } from "antd";
import DataSyndicationSourceSubscription from "containers/DataSyndicationSourceSubscription";
import React from "react";

const { TabPane } = Tabs;

interface DataSydicationActionTabsProps {
    readOnly: boolean;
    sourceId?: string;
}

const DataSydicationActionTabs: React.FC<DataSydicationActionTabsProps> = ({ readOnly, sourceId }) => {
    return (
        <Tabs defaultActiveKey="1">
            <TabPane tab="Subscriptions" key="2">
                <DataSyndicationSourceSubscription readOnly={readOnly} sourceId={sourceId} />
            </TabPane>
        </Tabs>
    );
};

export default DataSydicationActionTabs;
